import React from "react";
import AwesomeSlider from "react-awesome-slider";
import "react-awesome-slider/dist/styles.css";

export default function SliderImages() {
    return (
        <AwesomeSlider
            style={{
                width: "100%",
                marginTop: "10px",
                height: "450px",
            }}
        >
            <div data-src="https://www.contabilizei.com.br/contabilidade-online/wp-content/uploads/2020/05/hannah-morgan-ycVFts5Ma4s-unsplash-555x370.jpg.webp">
                <h1
                    style={{ position: "relative", top: "0px", color: "white" }}
                >
                    Aproveite as melhores ofertas
                </h1>
            </div>
            <div data-src="https://www.contabilizei.com.br/contabilidade-online/wp-content/uploads/2020/05/hannah-morgan-ycVFts5Ma4s-unsplash-555x370.jpg.webp">
                <h1
                    style={{ position: "relative", top: "0px", color: "white" }}
                >
                    Produtos de Qualidade e imperdiveis
                </h1>
            </div>
            <div data-src="https://www.contabilizei.com.br/contabilidade-online/wp-content/uploads/2020/05/hannah-morgan-ycVFts5Ma4s-unsplash-555x370.jpg.webp">
                <h1
                    style={{ position: "relative", top: "0px", color: "white" }}
                >
                    Aproveite as melhores ofertas
                </h1>
            </div>
        </AwesomeSlider>
    );
}
